import React, { useState, useEffect } from 'react';
import './culture.css';
import PaymentGatewayModal from './payment-gateway-modal.js';
import inde from './pictures/inde.png';
import cross from './pictures/Group 33788.png';
import { useLocation } from 'react-router-dom';
import api from '../../../../service/caller.js'


const ConsultationTable = () => {
  const [showModal, setShowModal] = useState(true);
  const [hasInsurance, setHasInsurance] = useState(false);
  const [isInsuranceValid, setIsInsuranceValid] = useState(false);
  const [insuranceProviders, setInsuranceProvider] = useState([]);
  const [insuranceErrorMessage, setInsuranceErrorMessage] = useState('');
  const [insuranceNumber, setInsuranceNumber] = useState('');
  const [billing, setBilling] = useState(null); // Stocke les données de facturation
  const [insuranceInfo, setInsuranceInfo] = useState(null); // Stocke les données de l'assurance
  const [insuranceProviderId, setInsuranceProviderId] = useState('');
  const [showPaymentGateway, setShowPaymentGateway] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const { state } = useLocation();
  const { billingID } = state;

  

  // Récupérer les informations de billing et d'assurance
  useEffect(() => {
    const fetchBillingData = async () => {
      try {
        const billingResponse = await api.get(`/clinic/getbilling/${billingID}`);
        setBilling(billingResponse.data);
      } catch (error) {
        console.error('Error fetching billing data:', error);
      }
    };

    fetchBillingData();
  }, [billingID]);



  // recuperer les assurances providers
  useEffect(() => {
    const fetchinsuranceProvider = async () => {
      try {
        const insuranceProviderResponse = await api.get('/api/allinsuranceproviders');

        // Si la réponse est un objet, mettez-le dans un tableau
        const providers = Array.isArray(insuranceProviderResponse.data)
          ? insuranceProviderResponse.data
          : [insuranceProviderResponse.data]; // Mettre dans un tableau si c'est un objet unique

        setInsuranceProvider(providers);
      } catch (error) {
        console.error('Error fetching insurance provider:', error);
      }
    };

    fetchinsuranceProvider();
  }, []);

  useEffect(() => {
    // Réinitialiser les informations liées à l'assurance lorsque "Non" est sélectionné
    if (!hasInsurance) {
      setInsuranceNumber('');
      setInsuranceProviderId('');
      setInsuranceInfo(null);
      setIsInsuranceValid(false);
      setInsuranceErrorMessage('');
    }
  }, [hasInsurance]);

  // verify si l'assurance est trouvee et  recupere les information pour cet insuranceNumber
  const validateInsurance = async () => {
    if (insuranceProviderId && insuranceNumber) {
      try {
        const response = await api.post('/api/validate-insurance', {
          insuranceProviderId,
          insuranceNumber,
        });

        const { valid, insurancedetails } = response.data;
        setIsFormSubmitted(true);
        if (valid && insurancedetails) {
          setIsInsuranceValid(true);
          setInsuranceInfo(insurancedetails);
          setInsuranceErrorMessage(''); // Efface le message d'erreur si tout va bien
        } else {
          setIsInsuranceValid(false);
          setInsuranceInfo(null); // Réinitialisez les informations d'assurance si elles ne sont pas valides
          if (insurancedetails?.expiryDate) {
            setInsuranceErrorMessage(
              `L'assurance est expirée depuis le ${insurancedetails.expiryDate.split('T')[0]}.`
            );
          } else {
            setInsuranceErrorMessage("Les informations d'assurance n'ont pas été trouvées.");
          }
        }
      } catch (error) {
        console.error("Erreur lors de la validation de l'assurance:", error.response || error);
        setIsInsuranceValid(false);
        setInsuranceInfo(null); // Réinitialisez les informations d'assurance en cas d'erreur
        setInsuranceErrorMessage('Une erreur est survenue lors de la validation.');
      }
    } else {
      setInsuranceErrorMessage('Veuillez remplir tous les champs.');
    }
  };

  // Calculer la marge
  const calculateMargin = (serviceCost, insuranceCoveragePercentage) => {
    const insuranceCoveredAmount = (serviceCost * insuranceCoveragePercentage) / 100;
    const patientPayable = serviceCost - insuranceCoveredAmount;
    return { insuranceCoveredAmount, patientPayable };
  };

  // Exemple de service coût et couverture
  const serviceCost = billing ? billing.amount : 0;
  const insuranceCoveragePercentage = insuranceInfo ? insuranceInfo.coverageDetails : 0;
  const { insuranceCoveredAmount, patientPayable } = calculateMargin(serviceCost, insuranceCoveragePercentage);

  return (
    <div className='replique '>
      {/* Invoice Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Invoice creation</h2>
            </div>
            <button className="modal-close"
              onClick={() => setShowModal(false)}>
              ← Retour
            </button>

            <div className="insurance-section">
              <h3> <span className='mitralette'></span> Insurance Informations</h3>
              <div className="insurance-radio-group">
                <p className='solution'>Avez-vous une assurance médicale ?</p>
                <label>
                  <input
                    type="radio"
                    name="hasInsurance"
                    checked={hasInsurance}
                    onChange={() => setHasInsurance(true)}
                  />
                  Oui
                </label>
                <label>
                  <input
                    type="radio"
                    name="hasInsurance"
                    checked={!hasInsurance}
                    onChange={() => setHasInsurance(false)}
                  />
                  Non
                </label>
              </div>

              {hasInsurance && (
                <div>
                  <form
                    className="newregistermodal"
                    onSubmit={(e) => {
                      e.preventDefault(); // Empêche le rechargement de la page
                      validateInsurance(); // Appelle votre fonction de validation
                    }}
                  >
                    <div className="form-row row">
                      {/* Sélection du fournisseur d'assurance */}
                      <div className="form-group col-md-6">
                        <label htmlFor="insuranceProviderId">Fournisseur d'assurance</label>
                        <select
                          id="insuranceProviderId"
                          value={insuranceProviderId}
                          onChange={(e) => setInsuranceProviderId(e.target.value)}
                          required
                        >
                          <option value="">Select provider</option>
                          {insuranceProviders.map((provider) => (
                            <option key={provider._id} value={provider._id}>
                              {provider.name}
                            </option>
                          ))}
                        </select>

                      </div>

                      {/* Champ numéro d'assurance */}
                      <div className="form-group col-md-6">
                        <label htmlFor="insuranceNumber">No Assurance</label>
                        <input
                          type="text"
                          id="insuranceNumber"
                          placeholder="Numero assurance"
                          value={insuranceNumber}
                          onChange={(e) => setInsuranceNumber(e.target.value)}
                          required
                        />
                      </div>
                    </div>


                    {hasInsurance && !isInsuranceValid && insuranceNumber && insuranceProviderId && isFormSubmitted && (
                      <div className="insurance-invalid">
                        {insuranceErrorMessage && (
                          <span className="ecrit">{insuranceErrorMessage}</span>
                        )}
                        <span>
                          <img src={cross} alt="cross" className="image-inside-span" width={'20px'} height={'20px'} />
                        </span>
                      </div>
                    )}
                    {isInsuranceValid && (
                      <div className="insurance-valid">
                        <span className="ecrit">ASSURANCE VALIDE</span>
                        <span>
                          <img src={inde} alt="Inde" className="image-inside-span" />
                        </span>
                      </div>
                    )}

                    {/* Bouton de validation */}
                    <button type="submit" className="validate-btn">
                      Validate
                    </button>
                  </form>
                </div>

              )}
            </div>

            <div className='line'></div>

            {(!hasInsurance || isInsuranceValid) && (
              <div className="invoice-details">
                {hasInsurance ? (
                  <>
                    <h3>
                      <span className="mitralette"></span> Détails de l'assurance :
                    </h3>
                    {insuranceInfo ? (
                      <>
                        <p className="colique">Nom : {insuranceInfo.insuredName}</p>
                        <p className="juda">✓ L'assurance couvre {insuranceInfo.coverageDetails}% des frais.</p>
                      </>
                    ) : (
                      <p className="info-message">Aucune information sur l'assurance disponible.</p>
                    )}
                  </>
                ) : (
                  <div className="insurance-invalid">
                    <span className="ecrit">Vous n'avez pas d'assurance.</span>
                  </div>
                )}


                <div className="invoice-table">
                  <p className='trit'>invoice :</p>
                  <table>
                    <thead>
                      <tr>
                        <th>Service</th>
                        <th>Coût</th>
                        <th>Insurance coverage</th>
                        <th>Patient Payable</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{billing ? billing.operationtype : "N/A"}</td>
                        <td>{billing ? billing.amount : "N/A"}</td>
                        <td>
                          {insuranceInfo && insuranceInfo.coverageDetails !== undefined
                            ? `${insuranceInfo.coverageDetails}%`
                            : "0%"}
                        </td>
                        <td>{patientPayable}</td>
                      </tr>
                      <tr>
                        <td>Total</td>
                        <td>{billing ? billing.amount : "N/A"}</td>
                        <td>{insuranceCoveredAmount}</td>
                        <td>{patientPayable}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='lala'>
                  <button className="payment-btn" onClick={() => setShowPaymentGateway(true)}>
                    Proceder Au Payement
                  </button>
                </div>
                {/* Add this to render the payment gateway modal */}
                {showPaymentGateway && (
                  <PaymentGatewayModal
                    billing={billing}
                    amountToPay={patientPayable}
                    onClose={() => setShowPaymentGateway(false)}
                  />
                )}

              </div>
            )}
          </div>
        </div>
      )}
    </div>

  );
};

export default ConsultationTable;